module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Maps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Chapter_01"
    }
  }, [_vm._v("1. The Rise of the Singapore Naval Base")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Chapter_02"
    }
  }, [_vm._v("2. The Allied Ground Forces in Malaya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Defeat at Slim River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Disaster at Muar and Johore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Endgame on Singapore Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-t",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044174_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da582d86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044174_Contents.vue
// module id = 72
// module chunks = 0